import { useCategories } from "../../providers/Categories";
import Category from "../category/Category";
import Heart from "../heart/Heart";
import { Box, CategoryDiv, Container, Content } from "./secondLineStyle";

const SecondLine = () => {
  const { categories, degCalc, categoriesLoad, categoryColors } =
    useCategories();

  return (
    <Container>
      <Box>
        <div>
          <Heart />
        </div>
      </Box>
      <Content>
        {categoriesLoad ||
          categories.map((item, index) => {
            return (
              <CategoryDiv key={item.id} $degCalc={degCalc} $index={index}>
                <div style={{ rotate: `-${degCalc * index + 240}deg` }}>
                  <Category
                    name={item.name}
                    color={categoryColors[item.id]}
                    categoryId={item.id}
                  />
                </div>
              </CategoryDiv>
            );
          })}
      </Content>
    </Container>
  );
};

export default SecondLine;
